// extracted by mini-css-extract-plugin
module.exports = {"main":"comachi-layout-module--main--3WT08"};